<template>
  <div class="h-100 pl-3 pr-2 pt-2 pb-2">
    <div
      style="
        position: fixed;
        top: 20px;
        left: 0;
        z-index: 1;
        backdrop-filter: blur(2px);
      "
      v-if="LoaderStatus || loader"
    >
      <Spinner />
    </div>
    <div>
      <div
        class="mt-2 newInt-full-container"
        id="scrollToTop"
        @scroll="onScroll"
      >
        <template
          v-if="
            alldata.length == 0 &&
            searchQuery == '' &&
            LoaderStatus == false &&
            ($route.query.type == '1' || $route.query.type == '2')
          "
        >
          <div
            class="d-flex flex-column align-items-center justify-content-center"
            style="height: calc(100vh - 304px)"
          >
            <div>
              <img
                src="../../assets/New-imgs/interviewProcess-icons/newInt-noData.svg"
                alt=""
              />
            </div>
            <div class="teams-empty-container-font">
              There is no interview process created, <br />
              click <strong> "+ Interview Process" </strong>
              button to create
            </div>
          </div>
        </template>
        <template
          v-else-if="
            $route.query.type == '0' &&
            page == 0 &&
            alldata.length == 0 &&
            searchQuery == '' &&
            LoaderStatus == false
          "
        >
          <div
            class="d-flex flex-column align-items-center justify-content-center"
            style="height: calc(100vh - 304px)"
          >
            <div>
              <img
                src="../../assets/New-imgs/interviewProcess-icons/inactive-int.svg"
                alt=""
              />
            </div>
            <div class="teams-empty-container-font">
              There are no inactive interview process
            </div>
          </div>
        </template>

        <template v-else-if="alldata.length == 0 && searchQuery != ''">
          <div
            class="d-flex flex-column align-items-center justify-content-center"
            style="height: calc(100vh - 304px)"
          >
            <div
              class="
                d-flex
                flex-column
                align-items-center
                justify-content-center
                h-100
              "
              v-if="!LoaderStatus && alldata.length == 0 && searchQuery != ''"
            >
              <div>
                <img
                  src="../../assets/img/accessconnew/emptyprivilageBig.svg"
                  alt=""
                />
              </div>
              <div
                v-if="searchQuery != 'Loader' && searchQuery != ''"
                class="mt-2 text-center access-font-color"
              >
                No matching results for
                <span class="access-font-color-b text-center text-break">
                  "{{ searchQuery }}"
                </span>
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="alldata.length > 0">
          <transition-group
            name="cell"
            class="d-flex flex-wrap gap-15 mt-1 ml-1"
            tag="div"
          >
            <div
              class="newInt-main-card relativeclass"
              :class="
                preview != int.interviewProcessID &&
                toggleIcon != int.interviewProcessID
                  ? 'newInt-main-card'
                  : 'newInt-main-card-active'
              "
              v-for="int in alldata"
              :key="int.interviewProcessID"
            >
              <div class="d-flex justify-content-between">
                <div class="relativeclass" style="width: 65%">
                  <div class="d-flex align-items-center">
                    <img
                      class="mb-1"
                      src="../../assets/New-imgs/interviewProcess-icons/newInt-main-icon.svg"
                      alt=""
                    />
                    <div
                      class="text-truncate ml-2 mr-2 newInt-card-heading mt-1"
                    >
                      <span
                        v-b-tooltip.hover.bottom="int.name"
                        class="d-inline-block text-truncate"
                        style="max-width: 100%"
                      >
                        {{ int.name }}</span
                      >
                    </div>
                  </div>
                </div>
                <div class="pointer d-flex align-items-center">
                  <div
                    v-if="roles.includes('CLONE_INTERVIEW') && !int.active"
                    @click="(cloneModal = true), cloninginactiveModal(int)"
                    class="mr-2 newIcons-hover"
                    v-b-tooltip.hover.top="'Clone'"
                  >
                    <img
                      src="../../assets/New-imgs/interviewProcess-icons/inactive-clone.svg"
                      alt=""
                    />
                  </div>
                  <div
                    v-if="!int.active"
                    @click.stop
                    class="mr-2 newIcons-hover"
                    @click="gotoActivate(int.interviewProcessID)"
                    v-b-tooltip.hover.top="'Activate'"
                  >
                    <img
                      src="../../assets/New-imgs/interviewProcess-icons/newInt-activateicon.svg"
                      alt=""
                    />
                  </div>

                  <div class="d-flex align-items-center">
                    <div class="mr-2" v-if="preview != int.interviewProcessID">
                      <img
                        class="newIcons-hover"
                        v-b-tooltip.hover.top="'View'"
                        src="../../assets/New-imgs/interviewProcess-icons/newInt-eyeicon.svg"
                        alt=""
                        @click.stop="particularCandidatedetail(int)"
                      />
                    </div>
                    <div
                      class="mr-2"
                      v-else
                      @click.stop="(preview = ''), (showdetails = false)"
                    >
                      <img
                        class="newIcons-hover"
                        @click="hideDetails()"
                        v-b-tooltip.hover.top="'Hide'"
                        src="../../assets/New-imgs/interviewProcess-icons/newInt-notview-icon.svg"
                        alt=""
                      />
                    </div>

                    <div
                      class="mr-2"
                      v-if="
                        int.active &&
                        (roles.includes('CLONE_INTERVIEW') ||
                          roles.includes('PUT_INTERVIEW') ||
                          roles.includes('DELETE_INTERVIEW'))
                      "
                    >
                      <img
                        class="newIcons-hover"
                        src="../../assets/New-imgs/interviewProcess-icons/newInt-edit-icon.svg"
                        alt=""
                        @click="toggleValue(int)"
                      />
                    </div>
                  </div>

                  <!-- if we click on info icon -->
                  <div
                    class="newInt-all-icons d-flex align-items-center"
                    v-if="toggleIcon == int.interviewProcessID"
                  >
                    <img
                      v-if="roles.includes('CLONE_INTERVIEW')"
                      class="newIcons-expand"
                      v-b-tooltip.hover.top="'Clone'"
                      src="../../assets/img/feedbackform/Duplicate.svg"
                      alt=""
                      @click="(cloneModal = true), cloningModal(int)"
                    />
                    <img
                      v-if="roles.includes('PUT_INTERVIEW') && int.active"
                      v-b-tooltip.hover.top="'Edit'"
                      class="ml-2 newIcons-expand"
                      src="../../assets/img/feedbackform/edit.svg"
                      alt=""
                      @click.stop="editInterviewProcess(int.interviewProcessID)"
                    />
                    <img
                      v-if="int.active && roles.includes('DELETE_INTERVIEW')"
                      v-b-tooltip.hover.top="'Delete'"
                      class="ml-2 newIcons-expand"
                      src="../../assets/img/feedbackform/delete.svg"
                      alt=""
                      @click.stop="
                        $bvModal.show('deleteIntModal'), deleteInterview(int)
                      "
                    />
                    <img
                      @click="hideDetails()"
                      class="ml-2 newIcons-expand"
                      src="../../assets/img/feedbackform/cancel.svg"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <div class="relativeclass">
                <div class="newInt-inactive-text-box" v-if="!int.active">
                  <div class="inactive-txt">Inactive</div>
                </div>
                <div
                  class="
                    d-flex
                    justify-content-around
                    align-items-center
                    newInt-cards
                    mt-3
                  "
                >
                  <div class="d-flex align-items-center flex-column">
                    <div v-if="int.process.length < 13" class="wb-greenfont">
                      0{{ int.process.length - 5 }}
                    </div>
                    <div v-else class="wb-greenfont">
                      {{ int.process.length - 5 }}
                    </div>
                    <div class="wbsmalltext">No. of Rounds</div>
                  </div>

                  <div class="d-flex align-items-center flex-column">
                    <div v-if="int.count < 10" class="wb-bluefont">
                      0{{ int.jdcount }}
                    </div>
                    <div v-else class="wb-bluefont">{{ int.jdcount }}</div>
                    <div class="wbsmalltext">Tagged Jobs</div>
                  </div>
                </div>
              </div>
            </div>
          </transition-group>
          <div
            style="margin: auto"
            class="d-flex justify-content-center mb-3"
            v-if="showLoader"
          >
            <b-spinner label="Loading..."></b-spinner>
          </div>
        </template>
      </div>
    </div>
    <deleteModal
      v-if="$route.query.status === 'interviewProcess'"
      :deleteIntProcess="deleteIntProcess"
      @resetPagination="resetPagination"
    />
    <CloneModal
      v-if="$route.query.status === 'interviewProcess' && cloneModal"
      :cloneModal="cloneModal"
      :cloningData="cloningData"
      :duplicatecloneName="duplicatecloneName"
      header="Clone Interview Process"
      subHeader="New Interview Process Name"
      placeholder="Enter Interview Process Name"
      errorMessage="Interview Process Name already exists"
      @closeCloneModal="closeCloneModal"
      @resetPagination="resetPagination"
      @handle-clone="cloneIp"
      @change-duplicate-name="duplicatecloneName = false"
      buttonName="Clone"
      :buttonLoader="buttonLoader"
    />
  </div>
</template>

<script>
import { getintprocess, addintprocess } from "../../utils/apiFunctions.js";
import deleteModal from "../../views/InterviewProcess/deleteModal.vue";
import CloneModal from "../../views/InterviewProcess/cloneModal.vue";
import { mapGetters } from "vuex";
import { required, maxLength } from "vuelidate/lib/validators";

import Spinner from "../../components/fixedcomponents/Spinner.vue";

import toast from "../../components/mixin/toast";

export default {
  name: "InterviewProcessDashboard",
  props: {
    interviewType: String,
    sortOrder: String,
    sortColumn: String,
    sort_selected: String,
  },
  mixins: [toast],
  components: {
    Spinner,
    deleteModal,
    CloneModal,
  },
  data() {
    return {
      loader: false,
      cloneModal: false,
      buttonLoader: false,
      cloningData: {},
      deleteIntProcess: {},
      viewIntProcess: {},
      toggleIcon: "",
      count: 30,
      page: 0,
      type: "Active",
      showdetails: false,
      showLoader: false,
      LoaderStatus: false,
      showsortcard: false,
      showfiltercard: false,
      showtypecard: false,
      duplicatecloneName: false,
      cloningName: "",
      pageEnd: null,
      total: null,
      custid: "",
      preview: "",

      // interviewType: "Active",
      alldata: [],
      singleCustomer: {},
      copyDeleteValue: {},
      sort_options: [
        { text: "Name(Asce)", value: "1" },
        { text: "Name(Desc)", value: "2" },
        { text: "Date Created(Asce)", value: "3" },
        { text: "Date Created(Desc)", value: "4" },
        { text: "Date Modified(Asce)", value: "5" },
        { text: "Date Modified(Desc)(Default)", value: "6" },
      ],
      interviewtypeoptions: [
        { text: "All", value: "2" },
        { text: "Active", value: "1" },
        { text: "Inactive", value: "0" },
      ],
      loopVar: 10,
    };
  },

  watch: {
    searchQuery(newValue, oldValue) {
      if (newValue != oldValue) {
        if (newValue != "Loader") {
          this.resetPagination();
        }
      }
    },
  },

  created() {
    this.$store.commit("searchVUEX/saveSearchQuery", "");
    this.LoaderStatus = true;
    this.resetPagination();
  },
  filters: {
    formatDate(dateStr) {
      const date = new Date(dateStr);
      const day = ("0" + date.getDate()).slice(-2);
      const month = ("0" + (date.getMonth() + 1)).slice(-2);
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    },
  },
  computed: {
    ...mapGetters(["roles"]),
    ...mapGetters("searchVUEX", {
      searchQuery: "getSearchQuery",
    }),
    sortName() {
      if (this.sort_selected == "1") {
        return "Name(Asce)";
      } else if (this.sort_selected == "2") {
        return "Name(Desc)";
      } else if (this.sort_selected == "3") {
        return "Date Created(Asce)";
      } else if (this.sort_selected == "4") {
        return "Date Created(Desc)";
      } else if (this.sort_selected == "5") {
        return "Date Modified(Asce)";
      }
      return "Date Modified(Desc)";
    },
  },
  validations() {
    return {
      cloningName: {
        required,
        maxLength: maxLength(128),
      },
    };
  },
  methods: {
    closeCloneModal() {
      this.cloneModal = false;
    },
    cloninginactiveModal(int) {
      this.cloningData = int;
      this.$v.$reset();
      this.duplicatecloneName = false;
    },
    cloningModal(int) {
      this.cloningData = int;
      this.$v.$reset();
      this.duplicatecloneName = false;
    },

    deleteInterview(int) {
      this.deleteIntProcess = int;
    },
    hideDetails() {
      this.$emit("viewIntProcess", {});
      this.toggleIcon = "";
    },
    toggleValue(data) {
      this.viewIntProcess = data;

      if (this.preview != "") {
        this.$emit("viewIntProcess", this.viewIntProcess);
      } else {
        this.$emit("viewIntProcess", {});
      }
      this.toggleIcon = data.interviewProcessID;
      this.preview = "";
    },

    // Managing tab redirect based on Interview type and Sort
    tabRedirect() {
      if (this.$route.query.type || this.$route.query.sort) {
        this.interviewType = this.$route.query.type;
        this.sort_selected = this.$route.query.sort;
        this.saveSort();
        return;
      }
      this.resetPagination();
    },
    onScroll(e) {
      // Get the target element of the scroll event.
      const { target } = e;
      // Check if the user has reached the bottom of the scrollable area.
      if (
        Math.ceil(target.scrollTop) >=
        target.scrollHeight - target.offsetHeight
      ) {
        // Check if there is more data to load.
        if (this.checkbetween(this.pageEnd, 0, this.total)) {
          this.page++;

          this.getInterview();
        }
      }
    },
    checkbetween(x, min, max) {
      // Return `true` if `x` is between `min` and `max`, otherwise `false`.
      return x > min && x < max;
    },
    resetPagination() {
      this.page = 0;
      this.alldata = [];
      this.LoaderStatus = true;
      this.loader = true;
      this.showLoader = false;
      this.toggleIcon = "";
      this.$emit("viewIntProcess", {});

      this.getInterview();
    },

    async getInterview() {
      let payload = {
        type: this.$route.query.type,
        page: this.page,
        count: 20,
        searchQuery: this.searchQuery,
        sortBy: this.sortColumn,
        order: this.sortOrder,
      };
      const response = await getintprocess(payload);
      if (response.status == 200) {
        if (this.page == 0) {
          this.alldata = response.data.data.data;
        } else {
          this.alldata = [...this.alldata, ...response.data.data.data];
        }
        this.total = response.data.data.total;
        this.pageEnd = response.data.data.pageEnd;
        this.LoaderStatus = false;
        if (response.data.data.total === response.data.data.pageEnd) {
          this.showLoader = false;
        } else {
          this.showLoader = true;
        }
      }
      this.LoaderStatus = false;
      this.loader = false;

      this.toggleIcon = "";
      this.preview = "";
      this.$emit("update-alldata-length", this.alldata.length);
    },

    particularCandidatedetail(int) {
      this.viewIntProcess = int;
      this.$emit("viewIntProcess", this.viewIntProcess);

      this.preview = int.interviewProcessID;
      this.toggleIcon = "";
    },

    // GO TO ACTIVATE INTERVIEW PROCESS
    gotoActivate(interviewProcessID) {
      this.$store.commit("scheduleInterviewVUEX/saveInterviewProcess", {});

      this.$router.push({
        name: "ActivateInterview",
        params: {
          interviewProcessID: interviewProcessID,
        },
        query: {
          status: this.$route.query.status,
          type: this.$route.query.type,
          sort: this.$route.query.sort,
        },
      });
    },

    editInterviewProcess(interviewProcessID) {
      this.$store.commit("scheduleInterviewVUEX/saveInterviewProcess", {});
      this.$router.push({
        name: `EditInterviewProcess`,
        params: {
          interviewProcessID: interviewProcessID,
          status_i: this.$route.query.status,
        },
        query: {
          type: this.interviewType,
          sort: this.sort_selected,
        },
      });
    },

    async cloneIp(cloningName) {
      try {
        this.buttonLoader = true;
        let clonedData = { ...this.cloningData };

        delete clonedData.jdTagged;
        delete clonedData.interviewProcessID;
        delete clonedData.jdcount;
        delete clonedData.active;
        delete clonedData.createdAt;
        delete clonedData.createdBy;
        delete clonedData.licenseKey;
        delete clonedData.lowerName;
        delete clonedData.updatedAt;

        const slicedProcess = clonedData.process.slice(1, -4);
        clonedData.process = slicedProcess;
        clonedData.numberOfRounds = clonedData.process.length;
        clonedData.name = cloningName;

        const res = await addintprocess(clonedData);
        if (res.status == 200) {
          this.successModal("Interview process cloned successfully!");
          this.buttonLoader = false;

          this.cloningName = "";

          this.cloneModal = false;
          // this.$v.$reset();
          this.resetPagination();
        } else if (res.status == 409) {
          this.duplicatecloneName = true;
          this.buttonLoader = false;
        }
      } catch (error) {
        this.duplicatecloneName = false;
        this.buttonLoader = false;

        throw new Error(`Failed! status:${error.status}`);
      }
    },
  },
};
</script>

<style scoped>
.z-10 {
  z-index: 10;
}
.round-text {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  /* identical to box height */
}
.tnt-sortcard .custom-control {
  padding-left: 2rem;
  padding-top: 5px;
  padding-bottom: 5px;
}
.sort-radio:nth-child(even) {
  background: #fdfdfd;
}
.sort-radio:nth-child(odd) {
  background: #f4f4f4;
}
.cell:nth-child(3n) {
  margin-right: 0;
}
.cell:nth-child(27n) {
  margin-bottom: 0;
}
.cell-move {
  transition: transform 1s;
}
.add-IP-btn {
  width: 200px;
  height: 50px;
  margin-right: 1vw;
  box-shadow: 0px 0px 6px gainsboro;
}
.IP-rounds {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;

  color: #696969;
}
.activate-txt {
  color: #038e00;
  text-decoration: underline;
}

.common-pg-heading {
  text-align: left;
  font-weight: var(--weight-B);
  font-size: var(--size-20);
  color: var(--bg-tertiary);
}
.lock-box {
  background: #ffffff;
  width: 52px;
  height: 52px;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: 4px;
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.15);
}
.lock-box::before {
  content: "";
  height: 29px;
  width: 10px;
  background: #d9d9d9;
  position: absolute;
  top: 52px;
}
.ip-process-details {
  overflow: auto;
  height: calc(100vh - 245px);
}
.final-lock-box {
  background: #aeaeae;
  width: 52px;
  height: 52px;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: 4px;
}
.rounds-container {
  width: 100%;
  padding: 15px;

  background: #f7f7f7;
  border-radius: 10px;
}
.ipd-manage-right-container {
  background: #ffffff;
  box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
  border-radius: 8px;
  width: 30%;
  margin-top: 15px;

  height: calc(100vh - 170px);
}
.emptyillusttext {
  font-weight: 400;
  font-size: 18px;
  color: #696969;
  position: absolute;
  left: 30%;
  top: 65%;
}
</style>
